import React, { Component } from "react";
import { connect } from "react-redux";
import Popover from "../../components/uielements/popover";
import IntlMessages from "../../components/utility/intlMessages";
import userpic from "../../image/user1.png";
import authAction from "../../redux/auth/actions";
import TopbarDropdownWrapper from "./topbarDropdown.style";
import { Button, Dropdown, Modal, Typography } from "antd";
import EditCurrentUser from "../AdminUser/editCurrent";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";

const { logout } = authAction;

class TopbarUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      modalVisible: false,
    };
  }

  setModalVisible(value) {
    this.setState({ modalVisible: value });
  }

  renderEditModal = () => {
    const { modalVisible } = this.state;
    return (
      <Modal
        title="Update Your Profile"
        open={modalVisible}
        destroyOnClose={true}
        style={{ top: 20 }}
        footer={null}
        onCancel={() => {
          this.setModalVisible(false);
        }}
      >
        <EditCurrentUser onSuccess={() => this.setModalVisible(false)} />
      </Modal>
    );
  };

  render() {
    const items = [
      {
        label: this.props.username,
        disabled: true,
        key: "1"
      },
      {
        type: 'divider'
      },
      {
        label: (
          <a
            className="isoDropdownLink"
            onClick={() => this.setModalVisible(true)}
            href="# "
            style={{ display: "flex", gap: 10, alignItems: "center" }}
          >
            <UserOutlined />
            <Typography>Edit Profile</Typography>
          </a>
        ),
        key: "2",
      },
      {
        label: (
          <a
            className="isoDropdownLink"
            onClick={this.props.logout}
            href="# "
            style={{ display: "flex", gap: 10, alignItems: "center" }}
          >
            <LogoutOutlined />
            <Typography>Log Out</Typography>
          </a>
        ),
        key: "3",
      },
    ];

    return (
      <div style={{ margin: "auto 0" }}>
        {this.renderEditModal()}
        <Dropdown menu={{ items }} trigger={["click"]}>
          <Button
            type="dashed"
            icon={<UserOutlined style={{ fontSize: 18 }} />}
            style={{ borderRadius: "50%", height: "40px", width: "40px" }}
          />
        </Dropdown>
      </div>
    );
  }
}
export default connect((state) => ({ username: state.Auth?.username }), { logout })(TopbarUser);
